import React from "react";
import { Form, Row, Col, Input, Button, Divider, Collapse } from "antd";
// import BrandAssetsForm from "./BrandAssetsForm"; // import your existing form
import styles from "../styles/BusinessInfo.module.css";
import BrandAssetsForm from "../../qbuilt_settings/brands/org/BrandAssetsForm";
import TextArea from "antd/es/input/TextArea";

export default function BrandSocials({ answers, onAnswerChange }) {
    const [form] = Form.useForm();

    // initialize with answers
    React.useEffect(() => {
        form.setFieldsValue({
            primary_phone: answers.phone,
            primary_email: answers.email,
            address: answers.address,
            website: answers.website,
            linkedin_handle: answers.socialHandles?.linkedin,
            instagram_handle: answers.socialHandles?.instagram,
            facebook_handle: answers.socialHandles?.facebook,
            youtube_handle: answers.socialHandles?.youtube,
            pinterest_handle: answers.socialHandles?.pinterest,
        });
    }, [answers, form]);

    // sync changes back to parent
    const handleValuesChange = (_, allValues) => {
        onAnswerChange("phone", allValues.primary_phone);
        onAnswerChange("email", allValues.primary_email);
        onAnswerChange("address", allValues.address);
        onAnswerChange("website", allValues.website);
        onAnswerChange("socialHandles", {
            linkedin: allValues.linkedin_handle,
            instagram: allValues.instagram_handle,
            facebook: allValues.facebook_handle,
            youtube: allValues.youtube_handle,
            pinterest: allValues.pinterest_handle,
        });
    };

    return (
        <div className={styles.brandAssistContent}>
            <h2 className={styles.slideTitle}>Brand Socials</h2>
            <p className={styles.slideSubtitle}>
                You can edit this data later as well.
            </p>

            <Form
                form={form}
                layout="vertical"
                initialValues={answers}
                onValuesChange={handleValuesChange}
            >
                <Row gutter={[10, 10]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Primary Phone" name="primary_phone">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Primary Email" name="primary_email">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item label="Address" name="address">
                    <TextArea rows={3} />
                </Form.Item>
                <Form.Item label="Website" name="website">
                    <Input />
                </Form.Item>
                <Collapse
                    // defaultActiveKey={["1"]}
                    defaultActiveKey={[]}
                    // ghost
                    items={[
                        {
                            key: "1",
                            label: "Social Media Handles",
                            children: (
                                <div>
                                    <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                label="Linkedin Handle"
                                                name="linkedin_handle"
                                                help="Mention only handle, not full url"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                label="Instagram Handle"
                                                name="instagram_handle"
                                                help="Mention only handle, not full url"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                label="Facebook Handle"
                                                name="facebook_handle"
                                                help="Mention only handle, not full url"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                label="YouTube Handle"
                                                name="youtube_handle"
                                                help="Mention only handle, not full url"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={[10, 10]}>
                                        <Col xs={24} sm={12}>
                                            <Form.Item
                                                label="Pinterest Handle"
                                                name="pinterest_handle"
                                                help="Mention only handle, not full url"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]}
                    style={
                        {
                            // border: "1px solid red",
                        }
                    }
                />
            </Form>
        </div>
    );
}
